import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-house",
  "use": "svg-house-usage",
  "viewBox": "0 0 8 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 8\" stroke=\"#000\" id=\"svg-house\"><path d=\"M1.5 4.5v3h5v-3z\" fill=\"#bbb\" /><path d=\"M.5 4l3.5-3.5l3.5 3.5\" fill=\"#543\" /><path d=\"M3 5.5h2\" stroke=\"#356\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol